module.exports = __webpack_public_path__ + "img/tianjiajiyi.f553f57a.png";